<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light navbar-stick-dark" data-navbar="sticky">
      <header-component></header-component>
    </nav>
    <header
      class="header text-white h-fullscreen pb-0 overflow-hidden"
      style="background-image: url(../assets/img/vector/16.png); background-color: #262a37"
    >
      <div
        class="overlay opacity-95"
        style="background-image: linear-gradient(to bottom, #09203f 0%, #537895 100%)"
      ></div>
      <div class="container text-center">
        <div class="row align-items-center h-100">
          <div class="col-md-8 mx-auto">
            <h1>Clinic Management Application</h1>
            <p class="lead mt-4 mb-7">
              Highly customizable Clinic Management Solution that doctors trust.
            </p>
          </div>

          <div class="col-md-8 mx-auto align-self-end">
            <img
              class="mt-7 aos-init aos-animate"
              src="../../../assets/img/preview/dhanvantari_3.png"
              alt="img"
              data-aos="fade-up"
            />
          </div>
        </div>
      </div>
    </header>
    <main class="main-content">
      <section class="section bg-gray overflow-hidden">
        <div class="container-fluid">
          <div class="row gap-y align-items-center">
            <div class="col-md-4 mx-auto text-center">
              <img
                class="border shadow-7 aos-init aos-animate"
                src="../../../assets/img/preview/medical_bricks_2.png"
                alt="..."
                data-aos="fade-right"
              />
            </div>

            <div class="col-md-4 mx-auto">
              <h3>Highly Customizable</h3>
              <p>
                Highly customizable work flow can accomodate different requirements of different
                physicians.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="section overflow-hidden">
        <div class="container-fluid">
          <div class="row gap-y align-items-center">
            <div class="col-md-4 mx-auto text-center">
              <img
                class="border shadow-7 aos-init aos-animate"
                src="../../../assets/img/preview/dhanvantari_5.png"
                alt="..."
                data-aos="fade-left"
              />
            </div>

            <div class="col-md-4 mx-auto order-md-first">
              <h3>Track Patient's Visits</h3>
              <p>
                It is very simple to track patient's all visits and view the details of that visit.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="section bg-gray overflow-hidden">
        <div class="container-fluid">
          <div class="row gap-y align-items-center">
            <div class="col-md-4 mx-auto text-center">
              <img
                class="border shadow-7 aos-init aos-animate"
                src="../../../assets/img/preview/dhanvantari_4.png"
                alt="..."
                data-aos="fade-right"
              />
            </div>

            <div class="col-md-4 mx-auto">
              <h3>Daily OPD Register</h3>
              <p>
                Now it becomes easy to maintain daily OPD register, you can print the file to save
                the hard copy.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container">
          <header class="section-header">
            <h2>Features</h2>
            <hr />
            <p class="lead">
              These are some important features which enhances our application and make it secure
              and reliable.
            </p>
            <br />
          </header>

          <div class="row gap-y text-center">
            <div class="col-md-6 col-xl-4 feature-1">
              <p class="feature-icon lead-8 text-info">
                <i class="icon-upload"></i>
              </p>
              <h5>Upload Backup</h5>
              <p class="text-muted">
                You can upload your data weekly. In case of damage of your laptop, this
                functionality will save your data securely to our server.
              </p>
            </div>

            <div class="col-md-6 col-xl-4 feature-1">
              <p class="feature-icon lead-8 text-danger">
                <i class="icon-printer"></i>
              </p>
              <h5>Printing Documents</h5>
              <p class="text-muted">
                You can print various documents like presciption, medical or fitness certificate,
                payment receipt, opd register, patient's history and many more.
              </p>
            </div>

            <div class="col-md-6 col-xl-4 feature-1">
              <p class="feature-icon lead-8 text-success">
                <i class="icon-chat"></i>
              </p>
              <h5>Dedicated live support</h5>
              <p class="text-muted">
                We provide a live support. Whenever you need us, we are just a phone call away.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- pricing section-->
      <pricing />
      <!--  /.pricing section-->

      <section class="section">
        <div class="container">
          <header class="section-header">
            <h2>Our Customers</h2>
            <hr />
            <p class="lead">
              Join us to experience very user friendly Clinic Management Application
            </p>
          </header>

          <div
            class="pb-7"
            data-provide="slider"
            data-autoplay="true"
            data-slides-to-show="4"
            data-dots="true"
          >
            <div>
              <span>Dr. Jayprakash Kamat</span> <br />
              <span>B.A.M.S.</span>
            </div>
            <div>
              <span>Dr. Kunal Jagtap</span> <br />
              <span>B.A.M.S.</span>
            </div>
            <div>
              <span>Dr. Saurabh Padhye</span> <br />
              <span>B.A.M.S.</span>
            </div>
            <div>
              <span>Dr. Gadre</span> <br />
              <span>B.A.M.S.</span>
            </div>
          </div>
        </div>
      </section>
      <section id="section-faq" class="section bg-gray">
        <div class="container">
          <header class="section-header">
            <small>FAQ</small>
            <h2>Frequently Asked Questions</h2>
            <hr />
            <p>
              Got a question? We've got answers. If you have some other questions, contact us using
              email.
            </p>
          </header>

          <div class="row gap-y">
            <div class="col-md-6 col-xl-4">
              <h5>Can we customize the app?</h5>
              <p>
                Absolutely! we can customize the app according to your workflow. we can change the
                forms, prescription design, billing structure according to your needs.
              </p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Does it include medicine database?</h5>
              <p>
                Yes it includes standard medicine database with brand names and molecules, and you
                can also update it according to your needs.
              </p>
            </div>

            <!-- <div class="col-md-6 col-xl-4">
              <h5>How long are your contracts?</h5>
              <p>
                Currently, we only offer monthly subscription. You can upgrade or cancel your
                monthly account at any time with no further obligation.
              </p>
            </div> -->

            <div class="col-md-6 col-xl-4">
              <h5>Can we buy this software online?</h5>
              <p>
                Unfortunately, there is no option to buy this software online. You can make a
                request through contact us form and our executive will reach out to you.
              </p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Does it work without internate? How do you protect the data?</h5>
              <p>
                Yes it works without internet. Its automated backup feature stores the data to our
                secure cloud environment whenver you have the internet connection.
              </p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Can I try your service for free?</h5>
              <p>
                Of course! We’re happy to offer a free plan to anyone who wants to try our service
                for 15 days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import header from "../../../components/Header.vue";
import standardImg from "../../../assets/img/preview/dribbble-3.jpg";
import advanceImg from "../../../assets/img/preview/dribbble-11.jpg";
import pricing from "../../../components/Pricing.vue";

export default {
  data: () => ({
    standardImg,
    advanceImg,
    mainPriceType: true,
  }),
  components: {
    "header-component": header,
    pricing,
  },
};
</script>
